'use client';

import React, { useEffect, useState } from 'react';
import PaymentDialog from '@/components/billing/PaymentDialog';

export default function GlobalPaymentDialog(): JSX.Element {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handler = (e: any) => {
      setMessage(e?.detail?.message || '');
      setOpen(true);
    };
    window.addEventListener('showPaymentDialog', handler);
    return () => window.removeEventListener('showPaymentDialog', handler);
  }, []);

  return (
    <PaymentDialog open={open} onClose={() => setOpen(false)} message={message} />
  );
}


